export default {
  toggleSidebarInProgress: (state, getters, rootState) =>
    rootState.actionsInProgress.toggleSidebar
};
